import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { Pagination, PaginationItem, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";

const PaginationDefault = ({
  filters,
  updateFilter,
  totalCount,
  limit,
  offset,
  onHandlePageChange,
  resetPageOnOffsetZero = false,
}) => {
  const currentOffset =
    filters && filters.get("offset") ? filters.get("offset") : offset ? offset : 0;
  const resultLimit = filters && filters.get("limit") ? filters.get("limit") : limit ? limit : 25;
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (resetPageOnOffsetZero && currentOffset === 0) {
      setCurrentPage(1);
    } else {
      setCurrentPage(Math.round(currentOffset / resultLimit) + 1);
    }
  }, [currentOffset, resultLimit, resetPageOnOffsetZero]);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    if (updateFilter) {
      updateFilter("offset", (value - 1) * resultLimit);
    }
    if (onHandlePageChange) {
      onHandlePageChange(value - 1);
    }
  };
  return (
    totalCount && (
      <div className="flex flex-row justify-center">
        <div className={`flex w-full justify-center px-0 py-2 md:px-0`}>
          <Stack alignItems={"center"}>
            <Pagination
              count={Math.ceil(totalCount / resultLimit)}
              onChange={handlePageChange}
              page={currentPage}
              renderItem={(item) => (
                <PaginationItem
                  slots={{
                    previous: ArrowBack,
                    next: ArrowForward,
                  }}
                  {...item}
                />
              )}
            />
          </Stack>
        </div>
      </div>
    )
  );
};
export default PaginationDefault;
